import { render, staticRenderFns } from "./SmsNotifications.vue?vue&type=template&id=249d1c8c"
import script from "./SmsNotifications.vue?vue&type=script&lang=ts"
export * from "./SmsNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports